import { makeAutoObservable } from 'mobx'
import type { ReactNode } from 'react'

class GlobalLoaderService {
  isShow = false
  content?: ReactNode
  /** 로더는 모달보다 위에 그려지므로, 사용자가 조작해야 하는 모달이 떠 있는 동안은 숨긴다 */
  isHiddenForModal = false

  constructor() {
    makeAutoObservable(
      this,
      {
        content: false,
      },
      { autoBind: true },
    )
  }

  get isVisible() {
    return this.isShow && !this.isHiddenForModal
  }

  setHiddenForModal(hidden: boolean) {
    this.isHiddenForModal = hidden
  }

  closeLoader() {
    this.isShow = false
  }

  openLoader(content?: ReactNode) {
    this.content = content
    this.isShow = true
  }
}

const globalLoaderService = new GlobalLoaderService()

export default globalLoaderService
